import type { SchoolSizeCostSchoolRow } from '@/features/reports/data/schoolSizeCost.types';
import { efficiencyStatusLabel } from '@/features/reports/data/schoolSizeCost.constants';
import { downloadStringMatrixAsPdf, downloadStringMatrixAsXlsx } from '@/features/reports/utils/teacherEquityAlertExports';

function fmtUsd(n: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n);
}

function fmtPct(n: number): string {
  const sign = n > 0 ? '+' : '';
  return `${sign}${n.toFixed(1)}%`;
}

const EXPORT_HEADERS = [
  'School',
  'Code',
  'Governorate',
  'District',
  'Size band',
  'Students',
  'Cost/student',
  'Tuition/student',
  'Surplus/student',
  'Expected cost (size)',
  'vs Scale %',
  'Status',
];

export function buildSchoolSizeCostExportMatrix(rows: SchoolSizeCostSchoolRow[]): string[][] {
  return rows.map((r) => [
    r.schoolName,
    r.schoolCode,
    r.governorateName,
    r.cityName,
    r.schoolSizeBandName,
    String(r.studentsCount),
    fmtUsd(r.costPerStudentUsd),
    fmtUsd(r.tuitionPerStudentUsd),
    fmtUsd(r.surplusPerStudentUsd),
    fmtUsd(r.expectedCostPerStudentUsd),
    fmtPct(r.varianceVsScalePct),
    efficiencyStatusLabel(r.efficiencyStatus),
  ]);
}

export async function exportSchoolSizeCostExcel(
  rows: SchoolSizeCostSchoolRow[],
  basename: string
): Promise<void> {
  const matrix = buildSchoolSizeCostExportMatrix(rows);
  await downloadStringMatrixAsXlsx(basename, 'School size vs cost', EXPORT_HEADERS, matrix);
}

export async function exportSchoolSizeCostPdf(
  rows: SchoolSizeCostSchoolRow[],
  basename: string,
  subtitles: string[]
): Promise<void> {
  const matrix = buildSchoolSizeCostExportMatrix(rows);
  await downloadStringMatrixAsPdf(basename, subtitles, EXPORT_HEADERS, matrix);
}

export function schoolSizeCostExportBasename(year: string): string {
  return `school-size-cost_${year}`;
}
